import React, { useContext, useEffect, useRef, useState } from 'react'
import { CheckValidation } from './Validations';
import { HideLoder, LogInSchoolID, LogInUserID, getpostalcodes, ShowLoder, userTimeZone, getBatchName, YYYYMMDD, formatPackageType, ymdToDate, scrollToFirstInvalidField, shipStationUrlTrack, validateFieldLengths, truncate } from '../JS/Common';
import { ThemeContext, UserContext } from '../App';
import { ApiGetCall, ApiGetCDNData, ApiPostCall } from '../JS/Connector';
import AlertsComp from './AlertsComp';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from "react-signature-canvas";
import Popup from './Popup';
import { useDispatch, useSelector } from 'react-redux';
import useConfig from '../Hooks/useConfig';
import CustomReactDatePicker from './CustomReactDatePicker';
import { setDefaultShippingMethod } from '../Store/Slices/authSlice';
import { useDefaultShipMethodCall } from '../Hooks';
import CustomFieldInfoIcon from './CustomFieldInfoIcon';

function CreateShippingCom(props) {
    const { shipping_company_name, organization, adminCallNode } = useConfig();
    const { UserData, setUserData } = useContext(UserContext);
    const { state, dispatch } = useContext(ThemeContext);
    const StateData = useSelector((state) => state.authData);
    const reduxDispatch = useDispatch();
    const [showcustominputs, setshowcustominputs] = useState("d-none");
    const [phonenoError, setphonenoError] = useState("");
    const [AllState, setallstate] = useState([]);
    const [showpackingtypelist, setshowpackingtypelist] = useState("d-none");
    const [ValidateError, setValidateError] = useState('');
    const [ValidateColor, setValidateColor] = useState('');
    const [shipmentButton, setshipmentButton] = useState(true);
    const initialPickupValidation = {
        errorMsg: "",
        isDisabled: true,
        initialDisabledMsg: "Please validate the shipping first to check the pickup availability.",
        showInitialDisabledMsg: true
    };
    const [pickupValidation, setPickupValidation] = useState(initialPickupValidation);
    const initialBatchData = {
        batchname: "",
        notes: "",
        createbatchflag: 1,
        Phoneno: "",
        Street1: "",
        Street2: '',
        city: "",
        state: 0,
        postalcode: "",
        labelsize: 0,
        Weight: "",
        boxsize: "",
        width: "",
        height: "",
        depth: "",
        fedex_company_name: "",
        warehouse_id: null,
        pickup_schedule_date: "",
        pickup_start_time: "",
        pickup_end_time: "",
        default_shipping_method: 0,
        devicetypevalue: 0
    }
    const [BatchData, setBatchData] = useState(initialBatchData);
    const [deliveryaddress, setdeliveryaddress] = useState({
        streetline1: "",
        streetline2: "",
        city: "",
        stateOrProvinceCode: "",
        postalCode: "",
        recipientsname: "",
        recipientsphone: "",
        companyname: ""
    });
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const accountnumber = process.env.REACT_APP_Fedex_Accountnumber;
    const navigate = useNavigate();
    const [commonDivShow, setCommonDivShow] = useState(false)
    const [batchTicketArray, setBatchTicketArray] = useState([])
    const schoolDetail = state?.ShippingType
    const [isChecked, setIsChecked] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [buildingData, setbuildingData] = useState([]);
    const [ReturnAddressId, setReturnAddressId] = useState(0);
    const [SignatureDataForPackedBy, setSignatureDataForPackedBy] = useState('');
    const [showPickupScheduler, setShowPickupScheduler] = useState(2);
    const [showEditReturnAddress, setShowEditReturnAddress] = useState(false);
    const [shipmentOptions, setShipmentOptions] = useState([]);
    const [selectedShipOption, setSelectedShipOption] = useState({ rateId: null, serviceCode: null });
    const [initialShipMethod, setInitialShipMethod] = useState(0);
    const [isDefaultSelected, setIsDefaultSelected] = useState(null);
    const [isValidateDisabled, setIsValidateDisabled] = useState(false);
    const [shipmentID, setShipmentId] = useState(null);
    const initialContactState = {
        name: "",
        email: "",
        phoneNo: ""
    }
    const [contactDetails, setContactDetails] = useState(initialContactState)

    const sigCanvasForPackedBy = useRef({});
    const shippingAddressRef = useRef(null);
    const isSelectedBuildingRef = useRef(null);

    const { DefaultShipMethodCall } = useDefaultShipMethodCall();

    useEffect(() => {
        setshowpackingtypelist("d-none");
        setshowcustominputs("d-none");
        async function ConditionalFetch() {
            if (props.shippingFlag == 1) {
                setBatchData(prev => ({ ...prev, depth: "", width: "", height: "" }));
                setIsDisabled(false);
                await GetSchoolReturnLocations(props.SelectedItems);
            } else {
                setIsChecked(true)
                setIsDisabled(true)
                setCommonDivShow(true)
                setBatchData(prev => ({ ...prev, createbatchflag: 2, depth: "", width: "", height: "" }));
                setshipmentButton(false)
                const tickets = await ShowTicketDataForBatch();
                await GetSchoolReturnLocations(tickets);
            }
            await GetAddress();
        }
        setLoading(true);
        ConditionalFetch();
        getpostalcodes(setallstate);
    }, [])

    function resetValidationState() {
        setshipmentButton(false);
        setShipmentOptions([]);
        setSelectedShipOption({ rateId: null, serviceCode: null });
        setIsValidateDisabled(false);
    }

    function updatePickupValidationForCarrier(method) {
        setBatchData(prev => ({ ...prev, pickup_schedule_date: method == 3 ? YYYYMMDD(getTomorrow()) : null, pickup_start_time: "", pickup_end_time: "" }));
        if (method == 1) {
            setPickupValidation({
                errorMsg: "Pickups cannot be scheduled currently for Fedex shipments, try using UPS or USPS if a pickup is needed.",
                isDisabled: true,
                initialDisabledMsg: "",
                showInitialDisabledMsg: false
            });
        } else if (method == 3) {
            setPickupValidation({
                errorMsg: "USPS pickups can only be scheduled one day in advance.",
                isDisabled: false,
                initialDisabledMsg: "",
                showInitialDisabledMsg: false
            });
        } else {
            setPickupValidation({
                errorMsg: "",
                isDisabled: false,
                initialDisabledMsg: "",
                showInitialDisabledMsg: false
            });
        }
    }

    function getTomorrow() {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        return d;
    }

    function updateBatchField(field, value) {
        setBatchData(prev => ({ ...prev, [field]: value }));
        resetValidationState();
    }

    function updateBatchFields(patch) {
        setBatchData(prev => ({ ...prev, ...patch }));
        resetValidationState();
    }

    async function ShowTicketDataForBatch() {
        return await ApiGetCall(`/schools/batches/data-by-id?batchId=${props.batchid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.packer_signature) {
                    setSignatureDataForPackedBy(responseRs.packer_signature)
                }
                const tickets = responseRs.ticket.length != 0 ? responseRs.ticket : [];
                setBatchTicketArray(tickets);
                return tickets;
            }
        });
    }

    async function GetSchoolReturnLocations(tickets = []) {
        var vArray = [];
        {
            tickets.map((item) => {
                vArray.push(item.id)
            })
        }
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            ticketIds: vArray
        });
        await ApiPostCall("/tickets/return-locations/school-batch", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setShowPickupScheduler(responseRs?.check_pickup_schedule || 2)
                setbuildingData(responseRs?.msg);
                const showSelectedBuilding = responseRs?.msg?.find(item => item?.is_selected == 1);
                if (showSelectedBuilding) {
                    isSelectedBuildingRef.current = showSelectedBuilding;
                    setReturnAddressId(showSelectedBuilding?.id);
                } else {
                    isSelectedBuildingRef.current = null;
                    setReturnAddressId(0);
                }
            }
        });
    }

    async function GetAddress() {
        const batchName = getBatchName(userTimeZone);
        await ApiGetCall(`/schools/address?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var delieveryaddress = responseRs.admin_address;
                var shippingaddress = responseRs.school_address;
                shippingAddressRef.current = shippingaddress;
                dispatch({ type: 'UPDATE', payload: { ShippingType: responseRs?.school_detail?.shipping_type } });
                if (delieveryaddress != null) {
                    setdeliveryaddress({
                        ...deliveryaddress, streetline1: delieveryaddress.street_line1, streetline2: delieveryaddress.street_line2, city: delieveryaddress.city, stateOrProvinceCode: delieveryaddress.state_or_province_code,
                        postalCode: delieveryaddress.postal_code, recipientsname: delieveryaddress.contact_name, recipientsphone: delieveryaddress.contact_number,
                        companyname: responseRs?.school_detail?.name
                    })
                }
                if (shippingaddress == "null") {
                    setBatchData(prev => ({ ...prev, Phoneno: "", Street1: "", Street2: "", city: "", state: 0, postalcode: "", labelsize: 0, Weight: "" }))
                } else {
                    const alreadySelectedBuildingRef = isSelectedBuildingRef.current;
                    if (alreadySelectedBuildingRef?.street_line1) {
                        setBatchData(prev => ({
                            ...prev,
                            Phoneno: alreadySelectedBuildingRef.phone_no || "",
                            Street1: alreadySelectedBuildingRef.street_line1 || "",
                            Street2: alreadySelectedBuildingRef.street_line2 || "",
                            city: alreadySelectedBuildingRef.city || "",
                            state: alreadySelectedBuildingRef.state || "",
                            postalcode: alreadySelectedBuildingRef.postal_code || "",
                        }));
                    } else {
                        setBatchData(prev => ({
                            ...prev,
                            Phoneno: shippingaddress.phone_num || "",
                            Street1: shippingaddress.street_line || "",
                            Street2: shippingaddress.street_line2 || "",
                            city: shippingaddress.city || "",
                            state: shippingaddress.state_or_province_code || "",
                            postalcode: shippingaddress.postal_code || "",
                        }));

                        if (alreadySelectedBuildingRef) {
                            setShowEditReturnAddress(true);
                        }
                    }
                }
                setBatchData(prev => ({
                    ...prev,
                    batchname: batchName,
                    notes: "",
                    createbatchflag: 1,
                    fedex_company_name: shippingaddress != "null" ? shippingaddress.fedex_company_name || responseRs?.school_detail?.name : responseRs?.school_detail?.name,
                    default_shipping_method: responseRs?.default_shipping_method || 0
                }));
                setContactDetails(prev => ({
                    ...prev,
                    name: `${responseRs?.user_details?.first_name} ${responseRs?.user_details?.last_name}`,
                    email: responseRs?.user_details?.email,
                    phoneNo: responseRs?.user_details?.phone
                }))
                setLoading(false);
            }
        });
    }

    const validatePhoneNo = (value, errorMsg) => {
        if (value != "") {
            if (value.length < 10 || value.length > 15) {
                setValidateError(errorMsg);
                setValidateColor("redText mt-1");
                return false;
            } else {
                setValidateError("");
                setValidateColor("");
                return true;
            }
        } else {
            setValidateError("Please provide a phone number for shipping.");
            setValidateColor("redText mt-1");
            return false;
        }
    };

    const validateShippingAddress = (key, errorMsg) => {
        if (!key || key === "0" || key === 0) {
            setValidateError(errorMsg);
            setValidateColor("redText mt-1");
            return false;
        } else {
            setValidateError("");
            setValidateColor("");
            return true;
        }
    }

    async function checkAddressAndRate() {
        var Fedex = process.env.REACT_APP_ShipStation_Fedex;
        var StampId = process.env.REACT_APP_ShipStation_Stamp;
        var UpsId = process.env.REACT_APP_ShipStation_Ups;
        var isFormValid = CheckValidation({ formID: 'CreateBatchDiv' });

        if (BatchData.Weight > 55 || BatchData.Weight <= 0) {
            setValidateError("Invalid Weight Value");
            setValidateColor("redText mt-1");
            return;
        } else {
            setValidateError("");
            setValidateColor("");
        }

        const requiredFields = [
            [deliveryaddress.streetline1, "Please provide a street line in delivery address."],
            [deliveryaddress.city, "Please provide a City in delivery address."],
            [deliveryaddress.stateOrProvinceCode, "Please provide a State in delivery address."],
            [deliveryaddress.postalCode, "Please provide a Postal Code in delivery address."],
        ];

        if (!showEditReturnAddress) {
            requiredFields.push(
                [BatchData.Street1, "Please provide a street line in return address."],
                [BatchData.city, "Please provide a City in return address."],
                [BatchData.state, "Please provide a State in return address."],
                [BatchData.postalcode, "Please provide a Postal Code in return address."],
            );
        }

        for (const [value, errorMsg] of requiredFields) {
            if (!validateShippingAddress(value, errorMsg)) {
                isFormValid = false;
                return;
            }
        }

        if (!validatePhoneNo(BatchData.Phoneno, "Invalid return address Phone No.")) {
            isFormValid = false;
            return;
        }

        if (!validatePhoneNo(deliveryaddress.recipientsphone, "Invalid delivery address Phone No.")) {
            isFormValid = false;
            return;
        }

        const lengthValidations = [
            [deliveryaddress.streetline1, 50, "Delivery address line 1 must be 50 characters or fewer."],
            [deliveryaddress.streetline2, 50, "Delivery address line 2 must be 50 characters or fewer."],
            [deliveryaddress.city, 35, "Delivery address city must be 35 characters or fewer."],
            [deliveryaddress.postalCode, 10, "Delivery postal code must be 10 characters or fewer."],
            [BatchData.Street1, 50, "Return address line 1 must be 50 characters or fewer."],
            [BatchData.Street2, 50, "Return address line 2 must be 50 characters or fewer."],
            [BatchData.city, 35, "Return address city must be 35 characters or fewer."],
            [BatchData.postalcode, 10, "Return address postal code must be 10 characters or fewer."],
        ];

        const lengthError = validateFieldLengths(lengthValidations);
        if (lengthError) {
            setValidateColor('redText mt-1');
            setValidateError(lengthError);
            isFormValid = false;
            return;
        }

        var verifyPayload = {
            "rate_options": {
                "carrier_ids": [StampId, UpsId, Fedex],
                // "service_codes": [
                //     "usps_priority_mail",
                //     "ups_ground",
                //     "fedex_ground"
                // ]
                "package_types": [
                    'small_flat_rate_box',
                    'medium_flat_rate_box',
                    'large_flat_rate_box',
                    'ups_express_box_small',
                    'ups_express_box_medium',
                    'ups_express_box',
                    'ups__express_box_large',
                    'ups_10_kg_box',
                    'ups_25_kg_box',
                    // 'fedex_extra_large_box_onerate',
                    // 'fedex_large_box_onerate',
                    // 'fedex_medium_box_onerate',
                    // 'fedex_small_box_onerate',
                    'fedex_10kg_box',
                    'fedex_25kg_box',
                    'fedex_large_box',
                    'fedex_medium_box',
                    'fedex_extra_large_box',
                    'package',
                ]
            },
            "shipment": {
                "ship_to": {
                    "name": truncate(deliveryaddress.recipientsname) || "",
                    "company_name": truncate(shipping_company_name) || "",
                    "phone": `${deliveryaddress.recipientsphone}`,
                    "address_line1": deliveryaddress.streetline1,
                    "address_line2": deliveryaddress.streetline2,
                    "city_locality": deliveryaddress.city,
                    "state_province": deliveryaddress.stateOrProvinceCode,
                    "postal_code": deliveryaddress.postalCode,
                    "country_code": "US"
                },
                "ship_from": {
                    "name": truncate(UserData.UserName) || "",
                    "company_name": truncate(BatchData.fedex_company_name) || "",
                    "phone": `${BatchData.Phoneno}` || "",
                    "address_line1": BatchData.Street1,
                    "address_line2": BatchData.Street2,
                    "city_locality": BatchData.city,
                    "state_province": BatchData.state,
                    "postal_code": BatchData.postalcode,
                    "country_code": "US"
                },
                "packages": [
                    {
                        "weight": {
                            "value": parseInt(BatchData.Weight),
                            "unit": "pound"
                        },
                        "dimensions": {
                            "length": parseInt(BatchData.depth),
                            "width": parseInt(BatchData.width),
                            "height": parseInt(BatchData.height),
                            "unit": "inch"
                        }
                    }
                ],
            },
            "display_type": 2,
            "building_id": ReturnAddressId || null,
            "building_warehouse_id": BatchData.warehouse_id || null,
            "confirmation": "none",
            "address_residential_indicator": "no"
        }

        if (!isFormValid) {
            scrollToFirstInvalidField('CreateBatchDiv');
            return;
        }
        setLoading(true);
        setIsValidateDisabled(true);
        const raw = JSON.stringify(verifyPayload);
        await ApiPostCall(`${adminCallNode}/batches/check-address-and-rate`, raw).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.success) {
                    setValidateColor('');
                    setValidateError('');
                    setShipmentId(responseRs.shipment_id);
                    if (responseRs?.rates?.length > 0) {
                        setShipmentOptions(responseRs?.rates);
                        const lowestRate = responseRs?.rates?.reduce((lowest, current) =>
                            current?.total_amount < lowest?.total_amount ? current : lowest
                        );
                        const methodToCarrier = { 1: "fedex", 2: "ups", 3: "stamps.com" };
                        const carrierToMethod = { fedex: 1, ups: 2, "stamps.com": 3 };

                        const targetCarrier = methodToCarrier[BatchData.default_shipping_method];
                        const carrierRates = BatchData.default_shipping_method != 0
                            ? responseRs?.rates?.filter((rate) => rate?.carrier?.toLowerCase() == targetCarrier)
                            : [];

                        if (BatchData.default_shipping_method != 0 && carrierRates?.length > 0) {
                            const lowestCarrierRate = carrierRates.reduce((lowest, current) =>
                                current?.total_amount < lowest?.total_amount ? current : lowest
                            );
                            setInitialShipMethod(BatchData.default_shipping_method);
                            updatePickupValidationForCarrier(BatchData.default_shipping_method);
                            setIsDefaultSelected(BatchData.default_shipping_method);
                            setSelectedShipOption({ rateId: lowestCarrierRate?.rate_id, serviceCode: lowestCarrierRate?.service_code || null });
                            setshipmentButton(true);
                        } else if (lowestRate) {
                            const method = carrierToMethod[lowestRate?.carrier?.toLowerCase()];
                            if (method) {
                                setInitialShipMethod(method);
                                updatePickupValidationForCarrier(method);
                            }
                            setIsDefaultSelected(null);
                            setSelectedShipOption({ rateId: lowestRate?.rate_id, serviceCode: lowestRate?.service_code || null });
                            setshipmentButton(true);
                        }
                    } else {
                        setShipmentOptions([]);
                        setValidateError('No shipping options found, double-check entered information and try again.');
                        setValidateColor('redText mt-1');
                    }
                } else {
                    setShipmentOptions([]);
                    setIsDefaultSelected(null);
                    setValidateColor('redText mt-1');
                    setValidateError(responseRs?.message);
                }
            }
        });
    }

    async function SaveCreateBatch(flag) {
        var isFormValid = CheckValidation({ formID: 'CreateBatchDiv' });
        if (!isFormValid) {
            scrollToFirstInvalidField('CreateBatchDiv');
            return;
        }
        setLoading(true);
        var signatureBase64 = null;
        if (UserData.signatureFlag == 1) {
            if (SignatureDataForPackedBy == '') {
                signatureBase64 = sigCanvasForPackedBy.current.isEmpty() ? null : sigCanvasForPackedBy.current.getTrimmedCanvas().toDataURL("image/png");
            } else {
                signatureBase64 = SignatureDataForPackedBy;
            }
        } else {
            signatureBase64 = null
        }
        const shippingMethod = props.shippingFlag == 1 ? 0 : 1;

        const contact_name = contactDetails.name || UserData.UserName || null;
        const contact_email = contactDetails.email || null;
        const contact_phone = contactDetails.phoneNo || parseInt(BatchData.Phoneno) || null;

        if (BatchData.pickup_schedule_date && BatchData.pickup_start_time && BatchData.pickup_end_time) {
            if (!contact_name || !contact_email || !contact_phone) {
                setAlerts(<AlertsComp msg={"Contact Name, Email and Phone No. are required"} show={true} variant={"danger"} />);
                setTimeout(() => {
                    setLoading(false)
                    setAlerts(<AlertsComp show={false} />)
                }, 2500);
                return;
            }
        }

        var newJson = {
            "selectAllFlag": props.selectAllFlag,
            "batchName": BatchData.batchname,
            "notes": BatchData.notes,
            "schoolId": LogInSchoolID,
            "batchFlag": props.shippingFlag == 1 ? BatchData.createbatchflag : 2,
            "weight": parseInt(BatchData.Weight),
            "batchPackerSignature": signatureBase64,
            "packerUserId": LogInUserID,
            "userTimeZone": userTimeZone,
            "shippingMethod": shippingMethod,
            "schoolBatchId": props.shippingFlag == 1 ? null : props.batchid,
            "tickets": props.shippingFlag == 1 ? props.SelectedItems : batchTicketArray,
            "rateId": selectedShipOption.rateId || null,
            "pickup_flag": showPickupScheduler ?? 2,
            "pickup_date": BatchData.pickup_schedule_date || null,
            "pickup_start_time": BatchData.pickup_start_time || null,
            "pickup_end_time": BatchData.pickup_end_time || null,
            "label_layout": BatchData.labelsize == 0 ? "PAPER_4X6" : BatchData.labelsize,
            "contact_name": contact_name,
            "contact_email": contact_email,
            "contact_phone": contact_phone,
            "building_id": ReturnAddressId == 0 ? null : ReturnAddressId || null,
            "service_code": selectedShipOption.serviceCode || null,
            "shipmentId": String(BatchData.state || "")?.toLowerCase() == "pr" ? shipmentID : null,
            "shipment": {
                "ship_from": {
                    "name": truncate(UserData.UserName) || "",
                    "company_name": truncate(BatchData.fedex_company_name) || "",
                    "phone": `${BatchData.Phoneno}` || "",
                    "address_line1": BatchData.Street1 || "",
                    "address_line2": BatchData.Street2 || "",
                    "city_locality": BatchData.city,
                    "state_province": BatchData.state,
                    "postal_code": BatchData.postalcode,
                    "country_code": "US"
                },
                "ship_to": {
                    "name": truncate(deliveryaddress.recipientsname) || "",
                    "company_name": truncate(shipping_company_name) || "",
                    "phone": `${deliveryaddress.recipientsphone}` || "",
                    "address_line1": deliveryaddress.streetline1 || "",
                    "address_line2": deliveryaddress.streetline2 || "",
                    "city_locality": deliveryaddress.city || "",
                    "state_province": deliveryaddress.stateOrProvinceCode || "",
                    "postal_code": deliveryaddress.postalCode || "",
                    "country_code": "US"
                },
            }
        }

        setValidateError("");
        setValidateColor("");

        var raw = JSON.stringify(newJson);
        if (props.shippingFlag == 1) {
            await ApiPostCall("/schools/batches/save", raw).then((result) => {
                if (isDefaultSelected) {
                    DefaultShipMethodCall(LogInSchoolID, isDefaultSelected);
                }
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    var tempuser = props.AllShipDevices.map(item => { return { ...item, isChecked: false } });
                    props.setAllShipDevices(tempuser);
                    const responseRs = JSON.parse(result);
                    if (responseRs.status == "success") {
                        var msg = BatchData.createbatchflag == 2 ? "Batch and Shipping Created Successfully." : "Batch Created Successfully.";
                        setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                        setTimeout(() => {
                            setLoading(false);
                            setBatchData(prev => ({ ...prev, batchname: '', notes: '' }));
                            setAlerts(<AlertsComp show={false} />);
                            if (BatchData.createbatchflag == 2) {
                                if (responseRs?.msg?.label?.label_download?.png) {
                                    shipStationUrlTrack(responseRs?.msg?.label?.label_download?.png);
                                }
                            }
                            navigate("/outgoing-batches");
                        }, 2500);
                    } else {
                        const errorMessage = responseRs?.msg?.label?.errors?.[0]?.message
                            || responseRs?.msg?.message
                            || responseRs?.msg?.error
                            || "Please ensure the accuracy of your data for ShipStation delivery.";

                        setAlerts(<AlertsComp show={true} variant="danger" msg={errorMessage} />);
                        setTimeout(() => {
                            setLoading(false);
                            setAlerts(<AlertsComp show={false} />)
                        }, 5000);
                    }
                }
            });
        } else {
            await ApiPostCall("/batch/normal-to-ship", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.status == "success") {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"Shipping Created Successfully."} />);
                        setTimeout(() => {
                            setLoading(false);
                            if (responseRs?.msg?.label?.label_download?.png) {
                                shipStationUrlTrack(responseRs?.msg?.label?.label_download?.png);
                            }
                            props.ClosePopup();
                            setAlerts(<AlertsComp show={false} />)
                            props.AllBatches(null, null, false);
                        }, 3500);
                    }
                    else {
                        const errorMessage = responseRs?.msg?.label?.errors?.[0]?.message
                            || responseRs?.msg?.message
                            || responseRs?.msg?.error
                            || "Please ensure the accuracy of your data for ShipStation delivery.";

                        setAlerts(<AlertsComp show={true} variant="danger" msg={errorMessage} />);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />)
                        }, 5000);
                    }
                }
            });
        }
    }

    async function ChangeDeviceType(devicetypevalue) {
        var vArray = [];
        {
            batchTicketArray.map((item, i) => {
                var vjson = {};
                vjson['id'] = item.id;
                vArray.push(vjson)
            })
        }
        if (devicetypevalue != 4 && devicetypevalue != 0) {
            var raw = JSON.stringify({
                schoolId: LogInSchoolID,
                deviceType: devicetypevalue,
                ticketIds: props.shippingFlag == 1 ? props.SelectedItems : vArray
            });
            await ApiPostCall("/schools/batches/calculate-weight", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setshowpackingtypelist("");
                    updateBatchFields({ devicetypevalue: devicetypevalue, Weight: responseRs, depth: "", width: "", height: "", boxsize: "0" });
                    setshowcustominputs("d-none");
                }
            });
        } else {
            setshowpackingtypelist("");
            updateBatchFields({ devicetypevalue: devicetypevalue, Weight: "", depth: "", width: "", height: "", boxsize: "0" });
            setshowcustominputs("d-none");
        }
    }
    function addcustominputs(selectedid) {
        var vVal = selectedid.split('-');
        if (selectedid == "custom") {
            setBatchData(prev => ({ ...prev, depth: "", width: "", height: "" }));
            setshowcustominputs("");
        } else {
            setBatchData(prev => ({ ...prev, depth: vVal[0], width: vVal[1], height: vVal[2] }));
            setshowcustominputs("d-none");
        }
    }
    function handlecheckboxchange(e) {
        resetValidationState();
        setValidateColor("");
        setValidateError("");
        setShowEditReturnAddress(false);

        if (e.target.checked == true) {
            setIsChecked(true)
            setBatchData(prev => ({ ...prev, createbatchflag: 2 }))
            setCommonDivShow(true)
            setshipmentButton(false)
        } else {
            setIsChecked(false)
            setBatchData(prev => ({ ...prev, createbatchflag: 1 }))
            setCommonDivShow(false)
            setshipmentButton(true)
        }
    }
    const clearSignatureForPackedBy = () => {
        sigCanvasForPackedBy.current.clear();
    };

    const handleReturnAddressChange = (e) => {
        const selectedId = e.target.value;
        const selectedBuilding = buildingData.find((item) => item.id === selectedId);
        const shippingAddress = shippingAddressRef?.current;
        setReturnAddressId(selectedId);
        if (selectedBuilding?.street_line1) {
            updateBatchFields({
                Phoneno: selectedBuilding?.phone_no || shippingAddress?.phone_num || "",
                Street1: selectedBuilding?.street_line1 || "",
                Street2: selectedBuilding?.street_line2 || "",
                city: selectedBuilding?.city || "",
                state: selectedBuilding?.state || "",
                postalcode: selectedBuilding?.postal_code || "",
                warehouse_id: selectedBuilding?.warehouse_id || null
            })
            setShowEditReturnAddress(false);
        } else if (selectedId == 0) {
            updateBatchFields({
                Phoneno: shippingAddress?.phone_num || "",
                Street1: shippingAddress?.street_line || "",
                Street2: shippingAddress?.street_line2 || "",
                city: shippingAddress?.city || "",
                state: shippingAddress?.state_or_province_code || "",
                postalcode: shippingAddress?.postal_code || "",
                warehouse_id: shippingAddress?.warehouse_id || null
            })
            if (shippingAddress?.street_line) {
                setShowEditReturnAddress(false);
            } else {
                setShowEditReturnAddress(true);
            }
        } else {
            updateBatchFields({
                Phoneno: shippingAddress?.phone_num || "",
                Street1: shippingAddress?.street_line || "",
                Street2: shippingAddress?.street_line2 || "",
                city: shippingAddress?.city || "",
                state: shippingAddress?.state_or_province_code || "",
                postalcode: shippingAddress?.postal_code || "",
                warehouse_id: shippingAddress?.warehouse_id || null
            })
            setShowEditReturnAddress(true);
        }
    }

    const selectCarrier = (method, carrier) => {
        setInitialShipMethod(method);
        updatePickupValidationForCarrier(method);
        setIsDefaultSelected(null);
        const carrierRates = shipmentOptions?.filter(
            (option) => option?.carrier?.toLowerCase() == carrier
        );

        if (carrierRates?.length > 0) {
            const lowestCarrierRate = carrierRates.reduce((lowest, current) =>
                current?.total_amount < lowest?.total_amount ? current : lowest
            );
            setSelectedShipOption({ rateId: lowestCarrierRate?.rate_id, serviceCode: lowestCarrierRate?.service_code || null });
            setshipmentButton(true);
        }
    };

    const isCarrierAvailable = (carrier) => shipmentOptions?.some(
        (option) => option?.carrier?.toLowerCase() == carrier
    );

    const modalbody = (
        <div id="CreateBatchDiv" className="px-2 parent">
            <div className="row">
                <div className='col-md-6'>
                    <div className="row ps-3 pt-3 align-items-center">
                        <div className='col-12 ps-0'>
                            <div className='FormLabel'>Batch Name:<label className='redText'>*</label></div>
                        </div>
                        {props.shippingFlag == 1 ?
                            <div className="col-12 ps-0">
                                <input type="text" autoComplete='off' name='batchname' className="form-control" required value={BatchData.batchname} onChange={(e) => setBatchData(prev => ({ ...prev, batchname: e.target.value }))} />
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                            :
                            <div className="col-12 ps-0">
                                <label className='col-md-12'><b>{props.batchname}</b></label>
                            </div>
                        }
                    </div>
                    <div className="row ps-3 align-items-center  pt-3">
                        <div className='col-12 ps-0'>
                            <div className='FormLabel'>Notes:</div>
                        </div>
                        <div className="col-12 ps-0 pt-2"><textarea type="text" name='notes' rows={2} className="form-control" value={BatchData.notes} onChange={(e) => setBatchData(prev => ({ ...prev, notes: e.target.value }))} /></div>
                    </div>
                </div>
                <div className='col-md-6'>
                    {UserData.signatureFlag == 1 && (
                        <div className="col-12 py-1 mt-2 text-center">
                            <div className="greyBox mx-2">
                                <div className='fw-600 font-15 text-center'>Packed By Signature:</div>
                                <div className='mt-2 text-center'>
                                    {SignatureDataForPackedBy ? (
                                        <img src={SignatureDataForPackedBy} alt="Packed By Signature" />
                                    ) : (
                                        <SignatureCanvas
                                            ref={sigCanvasForPackedBy}
                                            canvasProps={{ width: 320, height: 100, className: "signatureCanvas" }}
                                        />
                                    )}
                                </div>
                                <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForPackedBy}><u>Clear</u></label></div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {schoolDetail == 2 && (
                <div className='align-items-center py-4 d-flex px-0'>
                    <input id='shipSchoolDevices' className='form-check-input mt-0 me-2 ms-0 cursor-pointer' disabled={isDisabled} type="checkbox" checked={isChecked} onChange={(e) => handlecheckboxchange(e)} />
                    <label htmlFor='shipSchoolDevices'>Ship Devices</label>
                </div>
            )}
            {commonDivShow == true && (
                <div className='greyBox'>
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Delivery Address</div>
                            </div>
                            <hr className="mt-2" />

                            <div className='row'>
                                <div className='col-7'>
                                    <label className='w-100'>{shipping_company_name}</label>
                                    <label className='w-100'>{deliveryaddress.streetline1 || ""}, {deliveryaddress.streetline2 || ""}</label>
                                    <label className='w-100'>{deliveryaddress.city || ""}, {deliveryaddress.stateOrProvinceCode || ""} {deliveryaddress.postalCode || ""}</label>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between pt-3">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Return Address</div>
                            </div>
                            <hr className="mt-2" />

                            <label>{BatchData.fedex_company_name}</label>

                            <div className='col-12 text-start pb-1 shipdevice-font-style pt-2'>Building
                                <CustomFieldInfoIcon
                                    bodyLabel={<>
                                        <b>Note: </b>Changing the Return Address will also update the Return Location on all batched tickets
                                    </>}
                                />
                            </div>
                            <select className='pt-2' value={ReturnAddressId} onChange={handleReturnAddressChange}>
                                <option value="0">Default Shipping Address</option>
                                {buildingData?.length > 0 && buildingData?.map((item, index) => {
                                    return <option key={index} value={item.id}>
                                        {item.name}
                                    </option>
                                })}
                            </select>

                            <div className='row pt-3'>
                                <div className='col-11 pe-0'>
                                    {BatchData.Street1 ? (
                                        <>
                                            <label className='w-100'>{BatchData.Street1} {BatchData.Street2 ? `, ${BatchData.Street2}` : ""}</label>
                                            <label className='w-100'>{BatchData.city || ""}, {BatchData.state || ""} {BatchData.postalcode || ""}</label>
                                            <label className='w-100'>
                                                <b>Phone Number:</b> {BatchData.Phoneno || ""}
                                            </label>
                                        </>
                                    ) : (
                                        <label className='w-100'>Please add a Return Address</label>
                                    )}
                                </div>
                                <div className='col-1 ps-0'>
                                    <img title='Edit Return Address' src='/images/EditIconNew.svg' className='cursor-pointer'
                                        onClick={() => setShowEditReturnAddress(!showEditReturnAddress)} />
                                </div>
                            </div>

                            {showEditReturnAddress && (
                                <div className={`row pe-0 parent pt-3`}>
                                    <div className="col-md-6">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Phone No.*</div>
                                        <input type="text" autoComplete='off' name='phoneno' className="form-control" required
                                            value={BatchData.Phoneno} maxLength={15}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                updateBatchField('Phoneno', onlyNumbers);
                                            }} />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                        <span className="Emailinvalid">{phonenoError}</span>
                                    </div>
                                    <div className="col-md-6 pt-1">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 1*</div>
                                        <input type="text" autoComplete='off' name='City' className="form-control" maxLength={50} required value={BatchData.Street1} onChange={(e) => updateBatchField('Street1', e.target.value)} />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-md-6 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 2</div>
                                        <input type="text" autoComplete='off' name='City' className="form-control" maxLength={50} value={BatchData.Street2} onChange={(e) => updateBatchField('Street2', e.target.value)} />
                                    </div>
                                    <div className="col-md-6 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>City*</div>
                                        <input type="text" autoComplete='off' name='City' className="form-control" maxLength={35} required value={BatchData.city} onChange={(e) => updateBatchField('city', e.target.value)} />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-md-6 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>State*</div>
                                        <select required onChange={(e) => updateBatchField('state', e.target.value)}>
                                            <option value="0">Select</option>
                                            {AllState.map((item, i) => {
                                                return <option value={item.state_code} selected={BatchData.state == item.state_code}>{item.state_code}</option>
                                            })}
                                        </select>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-md-6 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Postal Code*</div>
                                        <input required type="number" autoComplete='off' name='postalcode' className="form-control" value={BatchData.postalcode}
                                            min={0} onChange={(e) => e.target.value?.length <= 10 && updateBatchField('postalcode', e.target.value)}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-md-6 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Country</div>
                                        <input type="text" autoComplete='off' value='US' disabled name='City' className="form-control" />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Shipping Method</div>
                            </div>
                            <hr className="mt-2" />

                            <div className="shipdevice-font-style">What device type are you shipping?</div>
                            <div className="pt-1">
                                <select required onChange={(e) => ChangeDeviceType(e.target.value)}>
                                    <option value="0">Select</option>
                                    <option value="3">iPad</option>
                                    <option value="1">Chromebook/Laptop</option>
                                    <option value="4">Other</option>
                                </select>
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                            <div className={` ${showpackingtypelist} pt-3`}>
                                <div>
                                    <div className="shipdevice-font-style">Weight (1 - 55 lbs)*</div>
                                    <div className="input-group pt-1 has-validation">
                                        <input type="number" autoComplete='off' name='weight' min={1} max={55} className="form-control inputOverRideBorderRight" required value={BatchData.Weight}
                                            onChange={(e) => { updateBatchField('Weight', e.target.value); }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        <span className="input-group-text">lbs</span>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div className="shipdevice-font-style pt-3">Box Size(Length x Width x Height)*</div>
                                    <div className="pt-1">
                                        <select required value={BatchData.boxsize} onChange={(e) => { updateBatchField('boxsize', e.target.value); addcustominputs(e.target.value) }}>
                                            <option value="0">Select</option>
                                            {BatchData.Weight >= 1 && BatchData.Weight <= 4 ?
                                                <>
                                                    <option value="12-8-4">12 x 8 x 4</option>
                                                    <option value="14-5-19">14 x 5 x 19</option>
                                                    <option value="custom">Custom</option>
                                                </>
                                                : BatchData.Weight >= 5 && BatchData.Weight <= 10 ?
                                                    <>
                                                        <option value="12-8-4">12 x 8 x 4</option>
                                                        <option value="13-10-7">13 x 10 x 7</option>
                                                        <option value="14-5-19">14 x 5 x 19</option>
                                                        <option value="custom">Custom</option>
                                                    </>
                                                    : BatchData.Weight >= 11 && BatchData.Weight <= 21 ?
                                                        <>
                                                            <option value="12-8-4">12 x 8 x 4</option>
                                                            <option value="13-10-7">13 x 10 x 7</option>
                                                            <option value="14-14-10">14 x 14 x 10</option>
                                                            <option value="custom">Custom</option>
                                                        </>
                                                        : BatchData.Weight >= 22 && BatchData.Weight <= 36 ?
                                                            <>
                                                                <option value="12-8-4">12 x 8 x 4</option>
                                                                <option value="13-10-7">13 x 10 x 7</option>
                                                                <option value="14-14-10">14 x 14 x 10</option>
                                                                <option value="18-16-8">18 x 16 x 8</option>
                                                                <option value="14-12-14">14 x 12 x 14</option>
                                                                <option value="custom">Custom</option>
                                                            </>
                                                            : <option value="custom">Custom</option>
                                            }
                                        </select>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className={`${showcustominputs} row parent pt-3`}>
                                    <div className="col-md-4 pe-0">
                                        <div className='input-group has-validation'>
                                            <input type="number" autoComplete='off' name='depth' className="form-control inputOverRideBorderRight" required value={BatchData.depth}
                                                min={0} onChange={(e) => updateBatchField('depth', e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderAll">X</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 px-0">
                                        <div className='input-group has-validation'>
                                            <input type="number" autoComplete='off' name='width' className="form-control inputOverRideBorderAll" required value={BatchData.width}
                                                min={0} onChange={(e) => updateBatchField('width', e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderAll">X</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 ps-0">
                                        <div className='input-group has-validation'>
                                            <input type="number" autoComplete='off' name='height' className="form-control inputOverRideBorderAll" required value={BatchData.height}
                                                min={0} onChange={(e) => updateBatchField('height', e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                        e.preventDefault();
                                                    }
                                                }} />
                                            <span className="input-group-text inputOverRideBorderLeft">in</span>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="shipdevice-font-style pt-3">Label Size *</div>
                                <div className="pt-1">
                                    <select required onChange={(e) => updateBatchField('labelsize', e.target.value)}>
                                        <option value="0">Select</option>
                                        <option value="PAPER_85X11_TOP_HALF_LABEL">8.5 x 11 Top Half</option>
                                        <option value="PAPER_4X6">4 x 6</option>
                                        <option value="PAPER_4X8">4 x 8</option>
                                    </select>
                                    <span className="form-text invalid-feedback" >
                                        *required
                                    </span>
                                </div>
                            </div>

                            {showPickupScheduler == 1 && (
                                <>
                                    <div className="d-flex align-items-center justify-content-between pt-3">
                                        <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Schedule a Pickup</div>
                                    </div>
                                    <hr className="mt-2" />

                                    <div className="col-md-6">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Pickup Schedule</div>
                                        <CustomReactDatePicker
                                            minDate={initialShipMethod == 3 ? getTomorrow() : new Date()}
                                            maxDate={initialShipMethod == 3 ? getTomorrow() : undefined}
                                            selectedDate={BatchData.pickup_schedule_date ? ymdToDate(BatchData.pickup_schedule_date) : null}
                                            onChangeHandler={(date) => setBatchData(prev => ({ ...prev, pickup_schedule_date: date ? YYYYMMDD(date) : null }))}
                                            inputName={"PickupSchedule"}
                                            placeholderText='MM-DD-YYYY'
                                            isDisabled={pickupValidation.isDisabled}
                                        />
                                    </div>
                                    <div className="col-md-12 pt-3">
                                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Pickup Timeframe
                                            <CustomFieldInfoIcon
                                                customWidth='210px'
                                                bodyLabel={<>
                                                    <b>Note: </b>Pickups can only be scheduled between 8:00 AM and 6:00 PM.
                                                </>}
                                            />
                                        </div>
                                        <div className='row'>
                                            <div className='col-6 pe-0'>
                                                <div className='input-group has-validation'>
                                                    <span className="input-group-text inputOverRideBorderRight">From</span>
                                                    <input
                                                        type="time"
                                                        className="form-control inputOverRideBorderAll"
                                                        name="pickup_start_time"
                                                        value={BatchData.pickup_start_time || ''}
                                                        min="08:00" max="18:00"
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (!val) {
                                                                setBatchData(prev => ({ ...prev, pickup_start_time: val }));
                                                                return;
                                                            }
                                                            const clamped = val < '08:00' ? '08:00' : val > '18:00' ? '18:00' : val;
                                                            setBatchData(prev => ({ ...prev, pickup_start_time: clamped }));
                                                        }}
                                                        disabled={pickupValidation.isDisabled}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-6 ps-0'>
                                                <div className='input-group has-validation'>
                                                    <span className="input-group-text inputOverRideBorderAll">To</span>
                                                    <input
                                                        type="time"
                                                        className="form-control inputOverRideBorderLeft"
                                                        name="pickup_end_time"
                                                        value={BatchData.pickup_end_time || ''}
                                                        min={BatchData.pickup_start_time || '08:00'}
                                                        max="18:00"
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (!val) {
                                                                setBatchData(prev => ({ ...prev, pickup_end_time: val }));
                                                                return;
                                                            }
                                                            const lowerBound = BatchData.pickup_start_time || '08:00';
                                                            const clamped = val < lowerBound ? lowerBound : val > '18:00' ? '18:00' : val;
                                                            setBatchData(prev => ({ ...prev, pickup_end_time: clamped }));
                                                        }}
                                                        disabled={pickupValidation.isDisabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <>
                                        {pickupValidation.showInitialDisabledMsg ? (
                                            pickupValidation.initialDisabledMsg && <label className='redText mt-2'>{pickupValidation.initialDisabledMsg}</label>
                                        ) : (
                                            pickupValidation.errorMsg && <label className='redText mt-2'>{pickupValidation.errorMsg}</label>
                                        )}
                                    </>
                                </>
                            )}
                        </div>
                        <div className='col-md-12 text-center mt-3'>
                            <button className={`SaveBtn text-center`} style={{ opacity: isValidateDisabled ? 0.5 : 1, cursor: isValidateDisabled ? "not-allowed" : "pointer" }} disabled={isValidateDisabled}
                                onClick={(e) => checkAddressAndRate()}>Validate Shipping</button>
                            <div className={`${ValidateColor}`}>{ValidateError}</div>
                        </div>
                        {shipmentOptions?.length > 0 && (
                            <div className='col-md-12'>
                                <div className="d-flex align-items-center justify-content-between pt-3">
                                    <div style={{ color: '#030E20', size: '18px', fontWeight: 600 }}>Available Carriers</div>
                                </div>
                                <hr className="mt-2" />

                                <div className="row px-3 mt-4">
                                    <div className='col-md-4 ps-0'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 1 ? 'is-selected' : ''} ${!isCarrierAvailable("fedex") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("fedex") && selectCarrier(1, "fedex")}
                                            style={{ opacity: isCarrierAvailable("fedex") ? 1 : 0.5, cursor: isCarrierAvailable("fedex") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 1 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 1} disabled={!isCarrierAvailable("fedex")} />
                                                    <label>FedEx</label>
                                                </div>
                                                <img src='/images/FedexIcon.svg' />
                                            </div>
                                            {initialShipMethod == 1 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='fedex-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 1} onChange={(e) => setIsDefaultSelected(e.target.checked ? 1 : null)} />
                                                    <label htmlFor='fedex-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 2 ? 'is-selected' : ''} ${!isCarrierAvailable("ups") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("ups") && selectCarrier(2, "ups")}
                                            style={{ opacity: isCarrierAvailable("ups") ? 1 : 0.5, cursor: isCarrierAvailable("ups") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 2 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 2} disabled={!isCarrierAvailable("ups")} />
                                                    <label>UPS</label>
                                                </div>
                                                <img src='/images/UPS_Logo.svg' />
                                            </div>
                                            {initialShipMethod == 2 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='ups-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 2} onChange={(e) => setIsDefaultSelected(e.target.checked ? 2 : null)} />
                                                    <label htmlFor='ups-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-md-4 pe-0'>
                                        <div
                                            className={`carrier-card ${initialShipMethod == 3 ? 'is-selected' : ''} ${!isCarrierAvailable("stamps.com") ? 'is-disabled' : ''}`}
                                            onClick={() => isCarrierAvailable("stamps.com") && selectCarrier(3, "stamps.com")}
                                            style={{ opacity: isCarrierAvailable("stamps.com") ? 1 : 0.5, cursor: isCarrierAvailable("stamps.com") ? 'pointer' : 'not-allowed' }}
                                        >
                                            <div className={`d-flex justify-content-between ${initialShipMethod == 3 ? 'mb-2' : ''}`}>
                                                <div>
                                                    <input className='form-check-input me-2' type="radio" checked={initialShipMethod == 3} disabled={!isCarrierAvailable("stamps.com")} />
                                                    <label>USPS</label>
                                                </div>
                                                <img src='/images/USPS_Logo.svg' />
                                            </div>
                                            {initialShipMethod == 3 && (
                                                <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                                                    <input id='usps-default' type='checkbox' className='form-check-input'
                                                        checked={isDefaultSelected == 3} onChange={(e) => setIsDefaultSelected(e.target.checked ? 3 : null)} />
                                                    <label htmlFor='usps-default'>Set as Default</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
    return (
        <>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"lg"} title={props.shippingFlag == 1 ?
                BatchData.createbatchflag == 1 ?
                    "Create Batch" :
                    "Create Batch and Label" :
                "Create Shipping"}
                closePopup={(e) => { props.ClosePopup(); setshipmentButton(true); setBatchData(initialBatchData); setPickupValidation(initialPickupValidation) }}
                modalBody={modalbody} handleSave={(e) => SaveCreateBatch(2)} visibleSaveBtn={shipmentButton}
                btnText={props.shippingFlag == 1 ?
                    BatchData.createbatchflag == 1 ?
                        "Create Batch" :
                        "Create Batch and Label" :
                    "Create Shipping"}
                isScrollable={true} />
        </>
    )
}

export default CreateShippingCom
